import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year3/Autumn/AdditionAndSubtraction/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'AdditionAndSubtraction',
  field: 'Number',
  weeks: [4, 8],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/AdditionAndSubtraction/1ApplyNumberBondsWithin10" */ './1ApplyNumberBondsWithin10'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/AdditionAndSubtraction/2AddAndSubtract1s" */ './2AddAndSubtract1s'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/AdditionAndSubtraction/3AddAndSubtract10s" */ './3AddAndSubtract10s'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/AdditionAndSubtraction/4AddAndSubtract100s" */ './4AddAndSubtract100s'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/AdditionAndSubtraction/5SpotThePattern" */ './5SpotThePattern'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/AdditionAndSubtraction/6Add1sAcrossA10" */ './6Add1sAcrossA10'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/AdditionAndSubtraction/7Add10sAcrossA100" */ './7Add10sAcrossA100'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/AdditionAndSubtraction/8Subtract1sAcrossA10" */ './8Subtract1sAcrossA10'
        )
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/AdditionAndSubtraction/9Subtract10sAcrossA100" */ './9Subtract10sAcrossA100'
        )
    }),
    // Step 10
    newSmallStepContent({
      ...BlockModel.smallSteps[9],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/AdditionAndSubtraction/10MakeConnections" */ './10MakeConnections'
        )
    }),
    // Step 11
    newSmallStepContent({
      ...BlockModel.smallSteps[10],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/AdditionAndSubtraction/11AddTwoNumbersNoExchange" */ './11AddTwoNumbersNoExchange'
        )
    }),
    // Step 12
    newSmallStepContent({
      ...BlockModel.smallSteps[11],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/AdditionAndSubtraction/12SubtractTwoNumbersNoExchange" */ './12SubtractTwoNumbersNoExchange'
        )
    }),
    // Step 13
    newSmallStepContent({
      ...BlockModel.smallSteps[12],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/AdditionAndSubtraction/13AddTwoNumbersAcrossA10" */ './13AddTwoNumbersAcrossA10'
        )
    }),
    // Step 14
    newSmallStepContent({
      ...BlockModel.smallSteps[13],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/AdditionAndSubtraction/14AddTwoNumbersAcrossA100" */ './14AddTwoNumbersAcrossA100'
        )
    }),
    // Step 15
    newSmallStepContent({
      ...BlockModel.smallSteps[14],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/AdditionAndSubtraction/15SubtractTwoNumbersAcrossA10" */ './15SubtractTwoNumbersAcrossA10'
        )
    }),
    // Step 16
    newSmallStepContent({
      ...BlockModel.smallSteps[15],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/AdditionAndSubtraction/16SubtractTwoNumbersAcrossA100" */ './16SubtractTwoNumbersAcrossA100'
        )
    }),
    // Step 17
    newSmallStepContent({
      ...BlockModel.smallSteps[16],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/AdditionAndSubtraction/17Add2DigitAnd3DigitNumbers" */ './17Add2DigitAnd3DigitNumbers'
        )
    }),
    // Step 18
    newSmallStepContent({
      ...BlockModel.smallSteps[17],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/AdditionAndSubtraction/18SubtractA2DigitNumberFromA3DigitNumber" */ './18SubtractA2DigitNumberFromA3DigitNumber'
        )
    }),
    // Step 19
    newSmallStepContent({
      ...BlockModel.smallSteps[18],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/AdditionAndSubtraction/19ComplementsTo100" */ './19ComplementsTo100'
        )
    }),
    // Step 20
    newSmallStepContent({
      ...BlockModel.smallSteps[19],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/AdditionAndSubtraction/20EstimateAnswers" */ './20EstimateAnswers'
        )
    }),
    // Step 21
    newSmallStepContent({
      ...BlockModel.smallSteps[20],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/AdditionAndSubtraction/21InverseOperations" */ './21InverseOperations'
        )
    }),
    // Step 22
    newSmallStepContent({
      ...BlockModel.smallSteps[21],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/AdditionAndSubtraction/22MakeDecisions" */ './22MakeDecisions'
        )
    })
  ]
});
export default Block;
